
import HeaderDashboard from "../../Components/HeaderDashboard";

const ReSchedule = () => {


    return (
        <>
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">My Booking</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/reservations/flight/ReSchedule" className="text-muted text-hover-primary">Booking Re-Schedule</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div class="row mamage_depo">
                        <div class="col-lg-9">
                            <h6 className='ruler'>Flight Re-Schedule</h6>
                        </div>
                        <div class="col-lg-3">
                            <a href="#" onclick="history.back()" class="click_back"><i class="fa fa-arrow-left"></i></a>
                        </div>
                    </div>
                        <div className="col-md-12">
                             <div className='table-responsive'>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Reference No</th>
                                        <th>Confirmation Number (PNR)</th>
                                        <th>Booking Status</th>
                                        <th>Ticketing Status</th>
                                        <th>Booking Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>D2WFA3247</td>
                                        <td>47M4GY</td>
                                        <td>Hold</td>
                                        <td>OnRequest</td>
                                        <td>Sat 18 Oct , 2025</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </div>
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>Travel Information</h6>
                        <div className='table-responsive'>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                            <th>Travel Date</th>
                            <th>Flight No.</th>
                            <th>Aircraft Type</th>
                            <th>From / Terminal </th>
                            <th>To / Terminal</th>
                            <th>Dep Time</th>
                            <th>Arr Time</th>
                            <th>Airline</th>
                        </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                    <td>Fri  05 Dec , 2025</td>
                                    <td>
                                        9P - 741
                                    </td>
                                    <td><samp>N/A</samp></td>
                                    <td class="dropdown-caps">SHJ </td>
                                    <td class="dropdown-caps">ISB </td>
                                    <td>05-Dec-2025,09:15,AM</td>
                                    <td>05-Dec-2025,01:10,PM</td>
                                    <td>9P</td>
                                </tr>
                                <tr>
                                    <td>Sat  31 Jan , 2026</td>
                                    <td>
                                        9P - 742
                                    </td>
                                    <td><samp>N/A</samp></td>
                                    <td class="dropdown-caps">ISB </td>
                                    <td class="dropdown-caps">SHJ </td>
                                    <td>31-Jan-2026,08:15,PM</td>
                                    <td>31-Jan-2026,10:50,PM</td>
                                    <td>9P</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>Re-Schedule Date</h6>
                        <div className='table-respons'>
                        <div class="col-md-3">
                            <label className="">Re-Schedule Date :</label>                       
                            <div class="datepicker-wrap">
                                <input placeholder="Select Date" type="date" name="selectfromdate" class="form-control hasDatepicker" id="txtTransactionFromDate" value="21/11/2025" />
                            </div>
                        </div>
                   
                        <div class="col-md-12">
                            <label className="">Write Comments</label>
                        
                           <textarea className="form-controls" rows="3" placeholder="Comments.."></textarea>
                        </div>
                        <div class="col-md-6 mb-3">
                            <button type="button" class="btn btn-primary mt-2">Submit Reschedule Request</button>
                            </div>
                    </div>
                        </div>
                   
                 

                </div>
            </section>
        </>
    );
};

export default ReSchedule;